import SvgIcon, { SvgIconProps } from '../components/SvgIcon';

interface Props extends SvgIconProps {}

const BackgroundPlaceholder = ({ ...props }: Props) => {
  return (
    <SvgIcon
      width={74}
      height={74}
      viewBox="0 0 74 74"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M61.5 0.25H12.5C9.2511 0.25 6.13526 1.54062 3.83794 3.83794C1.54062 6.13526 0.25 9.2511 0.25 12.5V61.5C0.25 64.7489 1.54062 67.8647 3.83794 70.1621C6.13526 72.4594 9.2511 73.75 12.5 73.75H61.5C64.7489 73.75 67.8647 72.4594 70.1621 70.1621C72.4594 67.8647 73.75 64.7489 73.75 61.5V12.5C73.75 9.2511 72.4594 6.13526 70.1621 3.83794C67.8647 1.54062 64.7489 0.25 61.5 0.25ZM12.5 8.41667H61.5C62.583 8.41667 63.6216 8.84687 64.3874 9.61265C65.1531 10.3784 65.5833 11.417 65.5833 12.5V46.6367L52.5167 35.4892C50.4921 33.8233 47.9518 32.9126 45.33 32.9126C42.7082 32.9126 40.1679 33.8233 38.1433 35.4892L8.41667 60.275V12.5C8.41667 11.417 8.84687 10.3784 9.61265 9.61265C10.3784 8.84687 11.417 8.41667 12.5 8.41667Z"
        fill="currentColor"
      />
      <path
        d="M20.6667 28.8333C24.0494 28.8333 26.7917 26.0911 26.7917 22.7083C26.7917 19.3256 24.0494 16.5833 20.6667 16.5833C17.2839 16.5833 14.5417 19.3256 14.5417 22.7083C14.5417 26.0911 17.2839 28.8333 20.6667 28.8333Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default BackgroundPlaceholder;
